import React from 'react';
import { Toaster } from 'react-hot-toast';

const ToasterProvider = () => {
  return <Toaster />;
};

export default ToasterProvider;
